module.exports = __webpack_public_path__ + "static/img/g_teams.82181ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build902/components/new-home/img/g_teams.png
// module id = 7fiq
// module chunks = 0